import { GeneralModel } from "./general.model";
import { Hub } from "./hub.model";

export class HubRouting extends GeneralModel {
    hubId: number;
    hub: Hub;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/hubRouting.model.ts